import { render } from "./FormNotice.vue?vue&type=template&id=54482c2c&scoped=true"
import script from "./FormNotice.vue?vue&type=script&lang=js"
export * from "./FormNotice.vue?vue&type=script&lang=js"

import "./FormNotice.vue?vue&type=style&index=0&id=54482c2c&scoped=true&lang=css"

import exportComponent from "/Users/rs/Development/alisops/aclu-sdic-ice-form/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54482c2c"]])

export default __exports__